import { mouths } from "./mouths";

export const optionsChart = {
  responsive: true,
  plugins: {
    legend: {
      position: 'bottom' as const,
    },
    title: {
      display: true,
    },
  },
}

export const factoryChart = (target: any, colors: Array<string>, type: string = "line") => {
  if (!target) return;
  if (type === "pie") {
    return [
      {
        data: target,
        fill: false,
        backgroundColor: colors,
        tension: 0.1
      }
    ]
  }
  const result = target.map(({ legenda, dados }: any, i: number) => ({
    label: legenda,
    data: dados,
    fill: false,
    backgroundColor: colors,
    tension: 0.1
  }))

  return result;
}

export const factoryLabels = (target: any) => {
  if (!target) return;

  const result = target.map((label: string) => {
    const year = label.split("-")[0]
    const mouth = label.split("-")[1]
    return `${mouths[Number(mouth) - 1]} ${year}`
  })

  return result
}